import { all } from "redux-saga/effects";
import { reducer as toastrReducer } from 'react-redux-toastr'
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { combineReducers } from "redux";
import { authReducer } from "./reducers/user.reducer";
import { preferenceReducer, timerReducer, wordReducer } from "./reducers/assessment.reducer";


const rootPersistConfig = {
  key: 'root',
  storage: storage,
  blacklist: []
};


const reducers = combineReducers({
  auth: authReducer,
  // activatePersonRedux: activatePersonRedux.reducer,
  toastr: toastrReducer,
  time: timerReducer,
  word: wordReducer,
  preferences: preferenceReducer,
});


const rootReducer = persistReducer({
  key: 'root',
  storage
}, reducers)

export default persistReducer(rootPersistConfig, rootReducer);


